import { camelizeKeys } from 'humps';
import { catalogsByKeys } from '../../config/catalogs';
import { fetchCatalog } from '../../services/rips-api.service';

const loadCatalogs = async ({ commit }) => {
  const types = catalogsByKeys.map((catalog) => catalog.name);

  const requests = types.map(fetchCatalog);
  const results = await Promise.all(requests);

  const catalogs = {};
  results.forEach(({ type, data, success }) => {
    if (success) {
      commit('SET_CATALOGS', { type, data });
      catalogs[type] = camelizeKeys(data);
    } else {
      console.warn(`Catalog ${type} was not loaded.`);
    }
  });

  localStorage.setItem('catalogs', JSON.stringify(catalogs));
};


export default {
  loadCatalogs
}